import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./create.css";

const CreatePage = ({
  handleSubmit,
  value,
  setValue,
  title,
  setTitle,
  cat,
  top,
  handleFileChange,
  setCat,
  setTop,
  img,
  err,
  url,
  setUrl,
}) => {
  return (
    <div className="create">
      <form onSubmit={handleSubmit}>
        <p
          style={{
            backgroundColor: "white",
            color: "red",
            borderRadius: "8px",
            textTransform: "capitalize",
          }}
        >
          {err && err}
        </p>
        <input
          type="text"
          placeholder="Title"
          className="title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
        />

        <div className="editor-container">
          <ReactQuill
            className="editor"
            theme="snow"
            placeholder="Body"
            value={value}
            onChange={setValue}
          />
        </div>

        <div className="item">
          <p>
            <h1>Is This A Top Story?</h1>
          </p>
          <div style={{ display: "flex", justifyContent: "space-evenly" }}>
            <div>
              <input
                type="radio"
                name="top"
                id="yes"
                checked={top === "yes"}
                value={"yes"}
                onChange={(e) => setTop(e.target.value)}
              />
              <label htmlFor="yes">Yes</label>
            </div>
            <div>
              <input
                type="radio"
                name="top"
                id="no"
                checked={top === "no"}
                value={"no"}
                onChange={(e) => setTop(e.target.value)}
              />
              <label htmlFor="no">No</label>{" "}
            </div>
          </div>
        </div>
        <div className="item">
          <h1>Category</h1>

          <div className="cat">
            <input
              type="radio"
              checked={cat === "daily-news"}
              name="cat"
              value={"daily-news"}
              id="art"
              onChange={(e) => setCat(e.target.value)}
              required
            />
            <label htmlFor="art">
              Daily News <br /> (Labarai da Rahotanni)
            </label>
          </div>

          <div className="cat">
            <input
              type="radio"
              checked={cat === "long-features"}
              name="cat"
              value={"long-features"}
              id="science"
              onChange={(e) => setCat(e.target.value)}
            />
            <label htmlFor="science">
              {" "}
              Long features <br /> (Makala)
            </label>
          </div>

          <div className="cat">
            <input
              type="radio"
              checked={cat === "opinion"}
              name="cat"
              value={"opinion"}
              id="technology"
              onChange={(e) => setCat(e.target.value)}
            />
            <label htmlFor="technology">
              Opinion <br /> (Ra'ayi)
            </label>
          </div>

          <div className="cat">
            <input
              type="radio"
              checked={cat === "life"}
              name="cat"
              value={"life"}
              id="cinema"
              onChange={(e) => setCat(e.target.value)}
            />
            <label htmlFor="cinema">
              Life <br /> (Rayuwa)
            </label>
          </div>

          <div className="cat">
            <input
              type="radio"
              checked={cat === "videos"}
              name="cat"
              value={"videos"}
              id="design"
              onChange={(e) => setCat(e.target.value)}
            />
            <label htmlFor="design">
              {" "}
              Videos <br /> (Bidiyo)
            </label>
          </div>

          <div className="cat">
            <input
              type="radio"
              checked={cat === "photo"}
              name="cat"
              value={"photo"}
              id="food"
              onChange={(e) => setCat(e.target.value)}
            />
            <label htmlFor="food">
              Photos <br /> (Hotuna){" "}
            </label>
          </div>
        </div>
        <div className="sub-img">
          <input
            type="url"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            className="title"
            placeholder="Youtube video link"
          />{" "}
          <div className="addImage">
            <label htmlFor="img">
              <h3>Add image</h3>{" "}
            </label>
            <input
              type="file"
              name=""
              id="img"
              hidden
              onChange={handleFileChange}
              className="image"
              accept="image/png, image/gif, image/jpeg"
            />
            <img src={img} alt="" width={"100px"} height={"auto"} />
          </div>
        </div>
        <input type="submit" className="submit" value="Submit" />
      </form>
    </div>
  );
};

export default CreatePage;
